import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

class DefaultContext {
  @tracked treeItem;

  get displayName() {
    if (this.selectFiltered === true) {
      return this.intl.t('selectFiltered');
    }

    if (this.treeItem.usesComponents) {
      return this.intl.t('allOptions');
    } else {
      return this.intl.t('allModels');
    }
  }

  constructor(treeItem, intl, options) {
    this.treeItem = treeItem;
    this.intl = intl;
    this.allSelected = options?.allSelected ?? false;
    this.selectFiltered = options?.selectFiltered ?? false;
    this.disabled = options?.disabled ?? false;
  }

  equals(obj) {
    if (this.selectFiltered === true) {
      return obj?.selectFiltered === true;
    }
    return obj?.allSelected === true;
  }
}

export default class DefaultTaskConfigContext extends Service {
  @service intl;

  getContext(treeItem, options) {
    return new DefaultContext(treeItem, this.intl, options);
  }
}
